package com.bikompanion.data

import kotlinx.serialization.Serializable

@Serializable
data class CityBikesNetworkDetailDto(
    val stations: List<CityBikesStationDto>,
)
